import { render, staticRenderFns } from "./directSectionCategories.vue?vue&type=template&id=647de809&scoped=true"
import script from "./directSectionCategories.vue?vue&type=script&lang=js"
export * from "./directSectionCategories.vue?vue&type=script&lang=js"
import style0 from "./directSectionCategories.vue?vue&type=style&index=0&id=647de809&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647de809",
  null
  
)

export default component.exports